<script>
import axios from "axios";
import moment from "moment";
import Drawer from "@/components/drawer";

// Custom Components
import PageHeader from "@/components/page-header";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import appConfig from "@/app.config";

import {
  otherOptions,
  priorityOpt,
  typeOptions,
} from "@/helpers/global.variable";

export default {
  namepage: {
    title: "Request Data Log",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Drawer,
  },
  data() {
    return {
      title: "Request and Logs",
      reqID: "",
      fullData: {},
      staffData: [{ text: "Auto Assign", value: "Auto Assign" }],
      isStillLoading: false,
      drawerOpener: false,
      logData: {},
      options: typeOptions,
      otherOptions: otherOptions,
      priorityOpt: priorityOpt,
      isLoading: false,
      appendinID: "",
      newStatus: "",
      newPriority: null,
      newAssignment: "Auto Assign",
      editDisplay: false,
      attachments: null,
      timer: null,
    };
  },
  mounted() {
    this.reqID = JSON.parse(localStorage.getItem("base_id"));
    this.openers();
    this.staff();
  },
  methods: {
    // * Get  Data of certain ticket
    async openers() {
      this.isStillLoading = true;
      if (this.reqID) {
        const response = await UserService.getFullReqData(this.reqID);
        if (response) {
          let name =
            response.guest !== null
              ? response.guest.last_name + " " + response.guest.first_name
              : response.room !== null
              ? response.room.booking !== null
                ? response.room.booking.last_name +
                  " " +
                  response.room.booking.first_name
                : "-"
              : "-";
          this.title = `Request And Logs Of #${response.ticket_number}`;
          this.fullData = response;
          this.isStillLoading = false;
        }

        this.newStatus = this.fullData.status;
        this.newPriority = this.fullData.priority;
        this.newTitle = this.fullData.title;
        this.newAssignment =
          this.fullData.assigned_by != null
            ? this.fullData.assigned_by.id
            : "Auto Assign";
      }
    },

    // * Get Staff list
    async staff() {
      const response = await UserService.getStaffList();
      for (let index = 0; index < response.length; index++) {
        const element = response[index];
        this.staffData.push({ text: element.first_name, value: element.id });
      }
    },

    // * Time converter
    convertTime(data) {
      return moment(data).fromNow();
    },

    // * Go back to MR page
    goBack() {
      this.$router.go(-1);
    },

    // * Drawer opener for log generating
    drawerOpenerProMax(faceID) {
      this.appendinID = faceID;
      this.drawerOpener = !this.drawerOpener;
    },

    // * Image uploading
    attachment(event) {
      this.attachments = event.target.files[0];
    },

    // * Adds new log
    async logger() {
      const formData = new FormData();
      formData.append("maintenance_detail", this.appendinID);
      formData.append(
        "is_internal",
        this.logData.is_internal ? this.logData.is_internal : false
      );
      if (this.logData.description) {
        formData.append("description", this.logData.description);
      }
      if (this.attachments != null) {
        formData.append("attachment", this.attachments);
      }
      this.isLoading = true;
      try {
        const response = await UserService.createMaintenceLog(formData);
        if (response) {
          Middleware.notification("Details successfully logged !!", "success");

          this.drawerOpener = !this.drawerOpener;
          this.openers();
        } else {
          Middleware.notification("There has been some error !!", "danger");
        }
      } catch (error) {
        errorHandler(error);
      }
      this.isLoading = false;
    },

    // * Clear data while closing drawer
    cancel() {
      this.editDisplay = !this.editDisplay;
      this.status = this.fullData.status;
      this.newPriority = this.fullData.priority;
      this.newTitle = this.fullData.title;
    },

    // * Download file
    toDownload(file) {
      axios({
        url: file, // File URL Goes Here
        method: "GET",
        responseType: "blob",
      }).then((res) => {
        var FILE = window.URL.createObjectURL(new Blob([res.data]));

        var docUrl = document.createElement("x");
        docUrl.href = FILE;
        docUrl.setAttribute("download", file);
        document.body.appendChild(docUrl);
        docUrl.click();
      });
    },

    // * Add new log
    async saveReq() {
      let saveData = new FormData();
      saveData.append("status", this.newStatus);
      saveData.append("priority", this.newPriority);
      saveData.append("title", this.newTitle);
      if (this.newAssignment == "Auto Assign") {
        let randomAssignment = Math.floor(
          Math.random() * this.staffData.length
        );
        if (randomAssignment == 0) {
          randomAssignment = 1;
        }
        const random = this.staffData[randomAssignment].value;
        saveData.append("assigned_by", random);
      } else {
        saveData.append("assigned_by", this.newAssignment);
      }
      try {
        const response = await UserService.updateReqData(this.reqID, saveData);
        if (response) {
          Middleware.notification("Changed successfully !!", "success");
        } else {
          Middleware.notification("There has been some error !!", "danger");
        }
      } catch (error) {
        errorHandler(error);
      }
      this.editDisplay = !this.editDisplay;
      this.openers();
    },

    // * Method is used to check file type
    checkFileType(file) {
      if (file == null) {
        return;
      }
      const parts = file.split(".");
      const extenstion = String(parts[parts.length - 1]).toLowerCase();
      const imgType = ["jpg", "jpeg", "png", "svg"];
      const excelType = ["xlsx", "xls"];
      const docType = ["doc", "docx"];
      const pdfType = ["pdf"];
      if (imgType.includes(extenstion)) {
        return "img";
      } else if (excelType.includes(extenstion)) {
        return "excel";
      } else if (docType.includes(extenstion)) {
        return "doc";
      } else if (pdfType.includes(extenstion)) {
        return "pdf";
      } else {
        return { type: "unknown", extenstion };
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :isButton="true"
      :action="goBack"
      text="Go Back"
    />
    <div class="row">
      <div class="col-md-3">
        <div class="card mb-3">
          <div class="p-3 text-capitalize" v-if="isStillLoading">
            <div class="placeholder-glow" v-for="no in 5" :key="no">
              <p class="placeholder w-25 placeholder-lg"></p>
              <p class="placeholder w-100 placeholder-lg"></p>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="placeholder-glow">
                  <p class="placeholder w-50 placeholder-lg"></p>
                  <p class="placeholder w-100 placeholder-lg"></p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="placeholder-glow">
                  <p class="placeholder w-50 placeholder-lg"></p>
                  <p class="placeholder w-100 placeholder-lg"></p>
                </div>
              </div>
            </div>
            <div class="placeholder-glow">
              <h6
                class="font-weight-semibold placeholder w-100 placeholder-lg"
              ></h6>
              <div
                class="placeholder placeholder-lg w-50 h-160 d-block mx-auto"
              ></div>
            </div>
          </div>
          <div class="position-relative p-3 text-capitalize" v-else>
            <!-- Edit Button -->
            <div v-if="!editDisplay" class="req-edit-icon">
              <i
                class="fas fa-pencil-alt text-success fs-5"
                v-b-popover.hover="'Edit request!'"
                @click="editDisplay = !editDisplay"
              ></i>
            </div>
            <!-- TITLE  -->
            <div class="mb-3" v-if="!editDisplay">
              <h6 class="font-weight-semibold">title</h6>
              <p>{{ fullData.title }}</p>
            </div>
            <div class="mb-3" v-else>
              <h6 class="font-weight-semibold">title</h6>
              <b-form-group>
                <b-form-input
                  class="form-input"
                  type="text"
                  placeholder="Display Type"
                  v-model="newTitle"
                ></b-form-input>
              </b-form-group>
            </div>
            <!-- ISSUE -->
            <div class="mb-3">
              <h6 class="font-weight-semibold">issue</h6>
              <p>
                {{
                  fullData.maintenance_issue
                    ? fullData.maintenance_issue.name
                      ? fullData.maintenance_issue.name
                      : "-"
                    : "-"
                }}
              </p>
            </div>
            <!-- DESCRIPTION -->
            <div class="mb-3">
              <h6 class="font-weight-semibold">description</h6>
              <p>{{ fullData.description ? fullData.description : "-" }}</p>
            </div>
            <!-- PRIORITY -->
            <div class="mb-3" v-if="!editDisplay">
              <h6 class="font-weight-semibold">priority</h6>
              <p
                class="badge mb-0 card-badge"
                :class="[
                  fullData.priority == 'Normal'
                    ? 'badge-soft-info'
                    : fullData.priority == 'Urgent'
                    ? 'badge-soft-warning'
                    : 'badge-soft-danger',
                ]"
              >
                {{ fullData.priority }}
              </p>
            </div>
            <div class="mb-3" v-else>
              <h6 class="font-weight-semibold">priority</h6>
              <b-form-group>
                <b-form-select
                  class="form-select"
                  type="text"
                  v-model="newPriority"
                  :options="priorityOpt"
                ></b-form-select>
              </b-form-group>
            </div>
            <!-- STATUS -->
            <div class="mb-3" v-if="!editDisplay">
              <h6 class="font-weight-semibold">status</h6>
              <p
                class="badge mb-0 card-badge"
                :class="[
                  fullData.status == 'pending'
                    ? 'badge-soft-danger'
                    : fullData.status == 'assigned'
                    ? 'badge-soft-info'
                    : fullData.status == 'in_progress'
                    ? 'badge-soft-warning'
                    : fullData.status == 'completed'
                    ? 'badge-soft-success'
                    : 'badge-soft-primary',
                ]"
              >
                {{ fullData.status ? fullData.status.replace("_", " ") : "" }}
              </p>
            </div>
            <div class="mb-3" v-else>
              <h6 class="font-weight-semibold">status</h6>
              <b-form-group>
                <b-form-select
                  class="form-select"
                  type="text"
                  v-model="newStatus"
                  :options="otherOptions"
                ></b-form-select>
              </b-form-group>
            </div>
            <!-- ASSIGN TO -->
            <div class="mb-3" v-if="!editDisplay">
              <h6 class="font-weight-semibold">Assigned To</h6>
              <p class="badge mb-0 card-badge badge-soft-success">
                {{
                  fullData.assigned_by
                    ? fullData.assigned_by.first_name
                    : newAssignment
                }}
              </p>
            </div>
            <div class="mb-3" v-else>
              <h6 class="font-weight-semibold">Assigned To</h6>
              <b-form-group>
                <b-form-select
                  class="form-select"
                  type="text"
                  v-model="newAssignment"
                  :options="staffData"
                ></b-form-select>
              </b-form-group>
            </div>
            <!-- CREATED BY -->
            <div>
              <div class="row">
                <div class="col-md-6">
                  <h6 class="font-weight-semibold">Create By</h6>
                  <p class="mb-0">
                    {{ fullData.created_by ? fullData.created_by : "Guest" }}
                  </p>
                </div>
                <div class="col-md-6">
                  <h6 class="font-weight-semibold">Created At</h6>
                  <p class="mb-0">
                    {{
                      fullData.created_at
                        ? convertTime(fullData.created_at)
                        : "-"
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <hr />
              <div class="d-flex justify-content-end" v-if="editDisplay">
                <button class="btn btn-danger d-block" @click="cancel()">
                  Cancel
                </button>
                <button class="btn btn-primary d-block ms-2" @click="saveReq()">
                  save
                </button>
              </div>
            </div>
            <!-- Attachment Image -->
            <div
              class="col-md-12"
              v-if="
                fullData.attachment != null ||
                (fullData.attachment != undefined && !isStillLoading)
              "
            >
              <h6 class="font-weight-semibold">Attachment</h6>
              <hr />
              <img
                :src="fullData.attachment"
                alt=""
                class="d-block mx-auto mw-100 attachment-img"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Add New button -->
      <div class="col-md-9">
        <div class="request-scrollble">
          <div class="mb-3">
            <div v-if="isStillLoading">
              <template>
                <div class="mb-3">
                  <h5 class="placeholder-glow"></h5>
                  <p class="placeholder w-100 placeholder-lg"></p>
                  <h5 class="placeholder-glow"></h5>
                  <p class="placeholder w-100 placeholder-lg"></p>
                  <h5 class="placeholder-glow"></h5>
                  <p class="placeholder w-100 placeholder-lg"></p>
                </div>
              </template>
            </div>
            <div v-else>
              <template
                v-if="
                  fullData.maintenance_log &&
                  fullData.maintenance_log.length !== 0
                "
              >
                <div
                  v-for="(data, index) in fullData.maintenance_log"
                  :key="data.id"
                >
                  <div class="card mb-3">
                    <div class="p-3">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <h6 class="mb-0">
                          {{ "Log #" }}
                          {{ fullData.maintenance_log.length - index }}
                        </h6>
                        <div v-if="data.created_at" class="">
                          <p class="mb-0 text-end">
                            {{ convertTime(data.created_at) }}
                          </p>
                        </div>
                      </div>
                      <hr class="my-2" />
                      <div class="d-flex">
                        <div class="w-100 me-3">
                          <div>
                            <h6 class="fw-bold">Description</h6>
                            <p>
                              {{ data.description ? data.description : "-" }}
                            </p>
                          </div>
                          <div
                            class="d-flex align-items-center justify-content-between"
                          >
                            <div v-if="data.is_internal != null">
                              <h6 class="fw-bold">Internal</h6>
                              <p v-if="data.is_internal == true" class="mb-0">
                                {{ "Internal" }}
                              </p>
                              <p class="mb-0" v-else>{{ "Not Internal" }}</p>
                            </div>

                            <div
                              class="d-flex align-items-center"
                              v-if="data.created_by"
                            >
                              <h6 class="fw-bold mb-0">Created By</h6>
                              <span class="mx-1">:</span>
                              <p class="mb-0">{{ data.created_by }}</p>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div
                            class="log-attachment-img d-flex align-items-center justify-content-center"
                          >
                            <template
                              v-if="checkFileType(data.attachment) == 'img'"
                            >
                              <img
                                @click="toDownload(data.attachment)"
                                :src="data.attachment"
                                alt=""
                                class="log-attachment-img d-block ms-auto rounded"
                              />
                            </template>
                            <template
                              v-else-if="
                                checkFileType(data.attachment) == 'excel'
                              "
                            >
                              <i
                                @click="toDownload(data.attachment)"
                                class="bx bx-file fs-1"
                              ></i>
                            </template>
                            <template
                              v-else-if="
                                checkFileType(data.attachment) == 'doc'
                              "
                            >
                              <i
                                @click="toDownload(data.attachment)"
                                class="bx bxs-file-doc fs-1"
                              ></i>
                            </template>
                            <template
                              v-else-if="
                                checkFileType(data.attachment) == 'pdf'
                              "
                            >
                              <i
                                @click="toDownload(data.attachment)"
                                class="bx bxs-file-pdf fs-1"
                              ></i>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <h6 class="mb-3">{{ "No logs found..." }}</h6>
              </template>
            </div>
          </div>
          <div class="sticky-btn">
            <button
              v-if="!editDisplay"
              class="btn btn-primary"
              @click="drawerOpenerProMax(fullData.id)"
            >
              New Note
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Drawer For LOGS -->
    <Drawer
      @close="drawerOpenerProMax"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="drawerOpener">
        <div class="row">
          <div class="col-md-12">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">New Note</h5>
            <hr />
            <div class="mb-3">
              <label for=""
                >Description<span class="text-danger">*</span></label
              >
              <textarea
                class="form-control form-control-sm"
                cols="5"
                rows="6"
                v-model="logData.description"
              ></textarea>
            </div>
          </div>
          <div class="col-md-6">
            <label for="">Type<span class="text-danger">*</span></label>
            <div class="d-flex align-items-center">
              <label for="type_change" class="cursor form-check-label">
                External
              </label>
              <div class="form-check form-switch form-switch-md d-flex ms-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="type_change"
                  v-model="logData.is_internal"
                />
                <label
                  for="type_change"
                  class="form-check-label align-items-center"
                >
                  Internal
                </label>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <label for="" class="d-block">Attachment</label>
            <input
              class="form-control"
              type="file"
              @change="attachment($event)"
            />
          </div>
          <div class="col-md-12">
            <hr />
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="drawerOpener = !drawerOpener"
              >Cancel</b-button
            >
            <b-button
              variant="outline-primary"
              class="float-end"
              @click="logger()"
              ><i
                v-if="isLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              save
            </b-button>
          </div>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.request-scrollble {
  max-height: calc(100vh - 130px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.req-edit-icon {
  position: absolute;
  top: 16px;
  right: 16px;
}

.attachment-img {
  object-fit: cover;
  max-height: 160px;
}
.h-160 {
  height: 160px;
}
.log-attachment-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.sticky-btn {
  position: sticky;
  bottom: 0;
}
</style>
